import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() => ({
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
    background: '#f7f6f6',
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    padding: '6px 12px',
  },
  titleGrid: {
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontWeight: 500,
    fontSize: 16,
    color: 'rgb(0 0 0 / 77%)',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    display: '-webkit-box',
    '-webkit-line-clamp': 1,
    '-webkit-box-orient': 'vertical'
  },
  leftComps: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginLeft: '10px',
  },
  paper: {
    borderRadius: 12,
    border: '1px solid rgba(0, 0, 0, 0.1)',
  },
  icon: {
    width: 20,
    height: 20,
  },
  buttonsGrid: {
    display: 'flex',
    alignItems: 'center',
  },
  closeButton: {
    padding: 4,
    marginLeft: 5,
    marginRight: -5,
  },
  children: {
    paddingTop: 12,
    paddingRight: 12,
    paddingLeft: 12,
    overflow: 'auto',
  },
}));
